import React from "react";
export var EntityLayoutsContext = React.createContext({});
export var EntityLayoutsProvider = EntityLayoutsContext.Provider;